module.exports = __webpack_public_path__ + "img/思维导图 1@2x.1841225a.png";